var _defs, _g, _path, _g2, _line, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamCoaches(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_71",
    "data-name": "Group 71",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 54,
    height: 50,
    viewBox: "0 0 54 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_204",
    "data-name": "Rectangle 204",
    width: 54,
    height: 50,
    fill: "none",
    stroke: "#52cb3c",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_66",
    "data-name": "Group 66"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_65",
    "data-name": "Group 65",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19",
    "data-name": "Line 19",
    y2: 15,
    transform: "translate(27 34)",
    fill: "none",
    stroke: "#52cb3c",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1651",
    "data-name": "Path 1651",
    d: "M42,41l5.028,14.246v.838",
    transform: "translate(-6.804 -6.642)",
    fill: "none",
    stroke: "#52cb3c",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1652",
    "data-name": "Path 1652",
    d: "M21.028,41,16,55.246v.838",
    transform: "translate(-2.592 -6.642)",
    fill: "none",
    stroke: "#52cb3c",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1653",
    "data-name": "Path 1653",
    d: "M50.252,12V36.3H5V12",
    transform: "translate(-0.81 -1.944)",
    fill: "none",
    stroke: "#52cb3c",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_68",
    "data-name": "Group 68"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67",
    "data-name": "Group 67",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1654",
    "data-name": "Path 1654",
    d: "M1,7.7V4.352H21.112L22.788,1h8.38l1.676,3.352H52.956V7.7Z",
    transform: "translate(-0.162 -0.162)",
    fill: "none",
    stroke: "#52cb3c",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_20",
    "data-name": "Line 20",
    x2: 5,
    transform: "translate(24 4)",
    fill: "none",
    stroke: "#52cb3c",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_70",
    "data-name": "Group 70"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69",
    "data-name": "Group 69",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_21",
    "data-name": "Line 21",
    x2: 54,
    transform: "translate(0 49)",
    fill: "none",
    stroke: "#52cb3c",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_21",
    "data-name": "Ellipse 21",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(21 14)",
    fill: "none",
    stroke: "#52cb3c",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(29 26)",
    fill: "none",
    stroke: "#52cb3c",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1655",
    "data-name": "Path 1655",
    d: "M27.6,18.866V17.19a4.19,4.19,0,1,0-8.38,0v5.028a4.189,4.189,0,0,1-4.19,4.19H10",
    transform: "translate(-1.62 -2.106)",
    fill: "none",
    stroke: "#52cb3c",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1656",
    "data-name": "Path 1656",
    d: "M50.274,21h-6.7a4.189,4.189,0,0,0-4.19,4.19v5.028a4.19,4.19,0,1,1-8.38,0V28.542",
    transform: "translate(-5.022 -3.402)",
    fill: "none",
    stroke: "#52cb3c",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1657",
    "data-name": "Path 1657",
    d: "M50,23.7l3.352-3.352L50,17",
    transform: "translate(-8.1 -2.754)",
    fill: "none",
    stroke: "#52cb3c",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_22",
    "data-name": "Line 22",
    y2: 2,
    transform: "translate(26 18)",
    fill: "none",
    stroke: "#52cb3c",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_23",
    "data-name": "Line 23",
    y2: 1,
    transform: "translate(26 22)",
    fill: "none",
    stroke: "#52cb3c",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_24",
    "data-name": "Line 24",
    x2: 1,
    transform: "translate(7 11)",
    fill: "none",
    stroke: "#52cb3c",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_25",
    "data-name": "Line 25",
    x2: 2,
    transform: "translate(45 11)",
    fill: "none",
    stroke: "#52cb3c",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_26",
    "data-name": "Line 26",
    x2: 2,
    transform: "translate(45 31)",
    fill: "none",
    stroke: "#52cb3c",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_27",
    "data-name": "Line 27",
    x2: 1,
    transform: "translate(7 31)",
    fill: "none",
    stroke: "#52cb3c",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamCoaches);
export default __webpack_public_path__ + "static/media/team-coaches.f713a30491ee2a5ac79bd8d322eaf709.svg";
export { ForwardRef as ReactComponent };